import * as React from 'react';
import { findDOMNode } from 'react-dom';

import './CKEditor.css';

interface Props {
  content?: string;
  config?: object;
  isScriptLoaded?: boolean;
  scriptUrl?: string;
  activeClass?: string;
  events: object;
  fullToolbar?: boolean;
}

interface State {
  isScriptLoaded: boolean;
}

const loadScript = require('load-script');
const defaultScriptUrl: string = 'https://cdn.ckeditor.com/4.10.1/standard/ckeditor.js';

/**
 * @description CKEditor component to render a CKEditor textarea with defined configs and all CKEditor events handler
 */
class CKEditor extends React.Component<Props, State> {
  // tslint:disable-next-line no-any
  private editorInstance: any;
  private unmounting: boolean;

  constructor(props: Props) {
    super(props);

    this.onLoad = this.onLoad.bind(this);

    this.state = {
      isScriptLoaded: props.isScriptLoaded ? (props.isScriptLoaded as boolean) : false
    };
  }

  // load ckeditor script as soon as component mounts if not already loaded
  componentDidMount() {
    if (!this.state.isScriptLoaded) {
      loadScript(this.props.scriptUrl ? this.props.scriptUrl : defaultScriptUrl, this.onLoad);
    } else {
      this.onLoad();
    }
  }

  componentWillReceiveProps(props: Props) {
    const editor = this.editorInstance;
    if (editor && editor.getData() !== props.content) {
      editor.setData(props.content);
    }
  }

  componentWillUnmount() {
    this.unmounting = true;
  }

  onLoad() {
    if (this.unmounting) {
      return;
    }

    this.setState({
      isScriptLoaded: true
    });

    // tslint:disable-next-line no-any
    if (!(window as any).CKEDITOR) {
      return;
    }

    let config = {};

    if (!this.props.config && this.props.fullToolbar) {
      config = {
        removePlugins: 'about,filetools,filebrowser,image,pastetext,pastefromword,uploadwidget,' +
        'uploadimage,wsc,scayt',
        removeButtons: 'Anchor,Paste,Cut,Copy',
        toolbar: [
          {
            name: 'document',
            items: ['Undo', 'Redo', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', '-', 'Maximize']
          },
          '/',
          {
            name: 'basicstyles',
            items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']
          },
          {
            name: 'paragraph',
            items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote']
          },
          {
            name: 'styles',
            items: ['Styles', 'Format']
          }
        ]
      };
    } else if (!this.props.config) {
      config = {
        removePlugins: 'about,filetools,filebrowser,image,pastetext,pastefromword,uploadwidget,uploadimage,wsc,scayt',
        removeButtons: 'Anchor,Paste,Cut,Copy',
        toolbar: [
          {
            name: 'document',
            items: ['Undo', 'Redo', '-', 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat', '-', 'Link',
              'Unlink']
          }]
      };
    }

    // tslint:disable-next-line no-any
    this.editorInstance = (window as any).CKEDITOR.appendTo(
      findDOMNode(this),
      this.props.config ? this.props.config : config,
      this.props.content,
    );

    // Register listener for custom events if any
    for (let event in this.props.events) {
      if (this.props.events[event]) {
        let eventHandler = this.props.events[event];
        // tslint:disable-next-line no-any
        this.editorInstance.on(event, (e: any) => eventHandler(e.editor.getData()));
      }
    }
  }

  render() {
    return <div className={this.props.activeClass}/>;
  }
}

export default CKEditor;



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/rich-text/CKEditor.tsx